import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  Button,
  Paper
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { verificationCode } from '../../api/modules/invite';
import { showMessage } from '../../utils';
import { useNavigate } from 'react-router-dom';
import { queryCouponByCouponCode } from '../../api/modules/invite';
import { isInApp } from '../../utils/environment';

const VerificationResult = () => {
    const location = useLocation();
    const account = location?.state?.account;
    const code = location?.state?.code;
    const useType = location?.state?.accountType;
    const [result, setResult] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        queryCouponByCouponCode({ code: code }, (rst) => {
            const { code, data, msg } = rst;
            if(code == 200 && data) {
                setResult(data);
            } else {
                showMessage(msg, 'error');
            }
        });
    }, []);

    const onCancel = () => {
        navigate('/campaigns/invitations/verification-code');
    }

    const onConfirm = () => {
      const params = {
        code: code,
        accountId: account.id,
        useType: useType || "Enter Code",
      };
      verificationCode(params, (rst) => {
        const { code, data, msg } = rst;
        if (data && data.success) {
            showMessage('Verification successful', 'success');
            setTimeout(() => {
                navigate('/campaigns/invitations/verification-success', { state: data });
            }, 1500);
        } else {
          showMessage('Verification failed', 'error');
        }
      });
    };
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: 'background.paper',
        zIndex: 1300,
        p: 2,
      }}
    >
      { 
        !isInApp() && (
          <Typography
          variant="h5"
          sx={{
            fontWeight: 900,
            mb: 4,
            textAlign: 'center',
            fontSize: '22px'
          }}
        >
          Verification Result
        </Typography>
        )
      }

      <Paper
        elevation={0}
        sx={{
          bgcolor: '#F9FAFB',
          borderRadius: '12px',
          p: 3,
          mb: 4,
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
          <Typography sx={{ color: '6B7280', fontSize: '14px' , fontWeight: 400, fontFamily: 'Roboto' }}>Order ID</Typography>
          <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#000', fontFamily: 'Roboto' }}>#{result?.couponId || ''}</Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
          <Typography sx={{ color: '6B7280', fontSize: '14px' , fontWeight: 400, fontFamily: 'Roboto' }}>Amount</Typography>
          <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#000', fontFamily: 'Roboto' }}>${result?.actualPrice}</Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
          <Typography sx={{ color: '6B7280', fontSize: '14px' , fontWeight: 400, fontFamily: 'Roboto' }}>Status</Typography>
          <Typography 
            sx={{ 
              fontWeight: 500,
              fontSize: '14px',
              color: '#000',
              fontFamily: 'Roboto'
            }}
          >
            {result?.status}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography sx={{ color: '6B7280', fontSize: '14px' , fontWeight: 400, fontFamily: 'Roboto' }}>Time</Typography>
          <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#000', fontFamily: 'Roboto' }}>{result?.validEndTime}</Typography>
        </Box>
      </Paper>

      <Box sx={{ 
        display: 'flex', 
        gap: 2,
        position: 'fixed',
        // bottom: 24,
        left: 24,
        right: 24,
      }}>
        <Button
          fullWidth
          variant="outlined"
          onClick={onCancel}
          sx={{
            borderRadius: 1,
            py: 1.5,
            borderColor: '#F3F4F6',
            color: '#000',
            fontSize: '14px',
          }}
        >
          Cancel
        </Button>
        <Button
          fullWidth
          variant="contained"
          onClick={onConfirm}
          sx={{
            borderRadius: 1,
            py: 1.5,
            bgcolor: 'black',
            fontSize: '14px',
            color: '#fff',
          }}
        >
          Confirm
        </Button>
      </Box>
    </Box>
  );
};

export default VerificationResult;
